import Layout from '../../components/dashboard/Layout';
import StatsCards from '../../components/dashboard/StatsCards';
import ExecutionsGraph from '../../components/dashboard/ExecutionsGraph';
import TaskList from '../../components/dashboard/TaskList';

export default function Dashboard() {
  return (
    <Layout>
      <div className="p-6">
        <StatsCards />
        <div className="mt-6 bg-gray-800 rounded-lg p-6">
          <h2 className="text-xl font-semibold text-white mb-4">Executions</h2>
          <ExecutionsGraph />
        </div>
        <div className="mt-6 bg-gray-800 rounded-lg p-6">
          <TaskList />
        </div>
      </div>
    </Layout>
  );
} 